//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./meeting_state.d.ts" />

import * as $ from "skir-client";
import * as x_account from "./account.js";
import * as x_calendar from "./calendar.js";
import * as x_call_utils from "./call_utils.js";
import * as x_crm from "./crm.js";
import * as x_methodology from "./methodology.js";
import * as x_user from "./user.js";

// -----------------------------------------------------------------------------
// enum MeetingSource.Platform
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias MeetingSource.Platform
 */
class MeetingSource_Platform extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct MeetingSource
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MeetingSource.Mutable`. */
export class MeetingSource extends $._FrozenBase {}

function initMeetingSource(target, initializer) {
  target.simulatedCall = initializer.simulatedCall ?? false;
  target.botProvider = initializer.botProvider ?? "";
  target.timestamp = initializer.timestamp ?? $.Timestamp.UNIX_EPOCH;
  target.platform = MeetingSource_Platform.create(initializer.platform ?? MeetingSource_Platform.UNKNOWN);
  target.spaceIds = $._toFrozenArray(
    initializer.spaceIds || []);
    target.user = x_user.User.create(initializer.user ?? x_user.User.DEFAULT);
    target.account = x_account.Account.create(initializer.account ?? x_account.Account.DEFAULT);
    target.calendarEvent = initializer.calendarEvent ? x_calendar.CalendarEventInfo.create(initializer.calendarEvent) : null;
    target.isPrivate = initializer.isPrivate ?? false;
    target.meetingUrl = initializer.meetingUrl ?? "";
    target.endedAt = initializer.endedAt ?? null;
    target.externalCrmLinkedAccountIds = $._toFrozenArray(
      initializer.externalCrmLinkedAccountIds || []);
}

// -----------------------------------------------------------------------------
// struct MeetingMethodology
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MeetingMethodology.Mutable`. */
export class MeetingMethodology extends $._FrozenBase {}

function initMeetingMethodology(target, initializer) {
  target.methodology = x_methodology.Methodology.create(initializer.methodology ?? x_methodology.Methodology.DEFAULT);
}

// -----------------------------------------------------------------------------
// struct MeetingMethodologyStatus
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `MeetingMethodologyStatus.Mutable`. */
export class MeetingMethodologyStatus extends $._FrozenBase {}

function initMeetingMethodologyStatus(target, initializer) {
  target.status = x_methodology.MethodologyStatus.create(initializer.status ?? x_methodology.MethodologyStatus.DEFAULT);
}

// -----------------------------------------------------------------------------
// struct ConversationState.ParticipantState
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `ConversationState.ParticipantState.Mutable`.
 *
 * @alias ConversationState.ParticipantState
 */
class ConversationState_ParticipantState extends $._FrozenBase {}

function initConversationState_ParticipantState(target, initializer) {
  target.participant = x_call_utils.Participant.create(initializer.participant ?? x_call_utils.Participant.DEFAULT);
  target.latestUtterances = $._toFrozenArray(
    initializer.latestUtterances || [],
    ConversationState_Utterance.create,
  );
}

// -----------------------------------------------------------------------------
// struct ConversationState.Utterance
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `ConversationState.Utterance.Mutable`.
 *
 * @alias ConversationState.Utterance
 */
class ConversationState_Utterance extends $._FrozenBase {}

function initConversationState_Utterance(target, initializer) {
  target.text = initializer.text ?? "";
  target.relativeTimestampSeconds = initializer.relativeTimestampSeconds ?? 0;
}

// -----------------------------------------------------------------------------
// struct ConversationState
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ConversationState.Mutable`. */
export class ConversationState extends $._FrozenBase {}

function initConversationState(target, initializer) {
  target.accumulatedText = initializer.accumulatedText ?? "";
  target.participantStates = $._toFrozenArray(
    initializer.participantStates || [],
    ConversationState_ParticipantState.create,
  );
  target.participants = $._toFrozenArray(
    initializer.participants || [],
    x_call_utils.Participant.create,
  );
  target.lastUpdate = initializer.lastUpdate ?? $.Timestamp.UNIX_EPOCH;
  target.crmContext = initializer.crmContext ? x_crm.MeetingCrmLink.create(initializer.crmContext) : null;
  target.detectedLanguage = initializer.detectedLanguage ?? "";
}

// -----------------------------------------------------------------------------
// struct ConversationSummary
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `ConversationSummary.Mutable`. */
export class ConversationSummary extends $._FrozenBase {}

function initConversationSummary(target, initializer) {
  target.summary = initializer.summary ?? "";
}

// -----------------------------------------------------------------------------
// struct UploadMetadata.KnownParticipant
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `UploadMetadata.KnownParticipant.Mutable`.
 *
 * @alias UploadMetadata.KnownParticipant
 */
class UploadMetadata_KnownParticipant extends $._FrozenBase {}

function initUploadMetadata_KnownParticipant(target, initializer) {
  target.name = initializer.name ?? "";
  target.email = initializer.email ?? "";
}

// -----------------------------------------------------------------------------
// struct UploadMetadata
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `UploadMetadata.Mutable`. */
export class UploadMetadata extends $._FrozenBase {}

function initUploadMetadata(target, initializer) {
  target.meetingId = initializer.meetingId ?? "";
  target.uploadId = initializer.uploadId ?? "";
  target.meetingTitle = initializer.meetingTitle ?? "";
  target.fileExtension = initializer.fileExtension ?? "";
  target.knownParticipants = $._toFrozenArray(
    initializer.knownParticipants || [],
    UploadMetadata_KnownParticipant.create,
  );
  target.hostUserName = initializer.hostUserName ?? "";
  target.hostCompanyName = initializer.hostCompanyName ?? "";
  target.status = initializer.status ?? "";
  target.progress = initializer.progress ?? "";
  target.error = initializer.error ?? "";
}

// -----------------------------------------------------------------------------
// struct RecallDesktopInfo
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `RecallDesktopInfo.Mutable`. */
export class RecallDesktopInfo extends $._FrozenBase {}

function initRecallDesktopInfo(target, initializer) {
  target.meetingId = initializer.meetingId ?? "";
  target.recallRecordingId = initializer.recallRecordingId ?? "";
  target.uploadToken = initializer.uploadToken ?? "";
  target.apiUrl = initializer.apiUrl ?? "";
  target.createdAt = initializer.createdAt ?? $.Timestamp.UNIX_EPOCH;
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "meeting_state.skir",
  [
    {
      kind: "enum",
      ctor: MeetingSource_Platform,
      name: "Platform",
      parentCtor: MeetingSource,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "GOOGLE_MEET",
          number: 1,
        },
        {
          name: "ZOOM",
          number: 2,
        },
        {
          name: "MICROSOFT_TEAMS",
          number: 3,
        },
        {
          name: "AIRCALL",
          number: 4,
        },
        {
          name: "MOBILE",
          number: 5,
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingSource,
      initFn: initMeetingSource,
      name: "MeetingSource",
      fields: [
        {
          name: "simulated_call",
          property: "simulatedCall",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "bot_provider",
          property: "botProvider",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "timestamp",
          property: "timestamp",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "platform",
          property: "platform",
          number: 5,
          type: {
            kind: "record",
            ctor: MeetingSource_Platform,
          },
        },
        {
          name: "space_ids",
          property: "spaceIds",
          number: 6,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "int32",
            },
          },
          mutableGetter: "mutableSpaceIds",
        },
        {
          name: "user",
          property: "user",
          number: 11,
          type: {
            kind: "record",
            ctor: x_user.User,
          },
          mutableGetter: "mutableUser",
        },
        {
          name: "account",
          property: "account",
          number: 12,
          type: {
            kind: "record",
            ctor: x_account.Account,
          },
          mutableGetter: "mutableAccount",
        },
        {
          name: "calendar_event",
          property: "calendarEvent",
          number: 13,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: x_calendar.CalendarEventInfo,
            },
          },
        },
        {
          name: "is_private",
          property: "isPrivate",
          number: 14,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "meeting_url",
          property: "meetingUrl",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "ended_at",
          property: "endedAt",
          number: 16,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "external_crm_linked_account_ids",
          property: "externalCrmLinkedAccountIds",
          number: 17,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableExternalCrmLinkedAccountIds",
        },
      ],
      removedNumbers: [
        0,
        10,
        2,
        7,
        8,
        9,
      ],
    },
    {
      kind: "struct",
      ctor: MeetingMethodology,
      initFn: initMeetingMethodology,
      name: "MeetingMethodology",
      fields: [
        {
          name: "methodology",
          property: "methodology",
          number: 0,
          type: {
            kind: "record",
            ctor: x_methodology.Methodology,
          },
          mutableGetter: "mutableMethodology",
        },
      ],
    },
    {
      kind: "struct",
      ctor: MeetingMethodologyStatus,
      initFn: initMeetingMethodologyStatus,
      name: "MeetingMethodologyStatus",
      fields: [
        {
          name: "status",
          property: "status",
          number: 0,
          type: {
            kind: "record",
            ctor: x_methodology.MethodologyStatus,
          },
          mutableGetter: "mutableStatus",
        },
      ],
    },
    {
      kind: "struct",
      ctor: ConversationState_ParticipantState,
      initFn: initConversationState_ParticipantState,
      name: "ParticipantState",
      parentCtor: ConversationState,
      fields: [
        {
          name: "participant",
          property: "participant",
          number: 0,
          type: {
            kind: "record",
            ctor: x_call_utils.Participant,
          },
          mutableGetter: "mutableParticipant",
        },
        {
          name: "latest_utterances",
          property: "latestUtterances",
          number: 1,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: ConversationState_Utterance,
            },
          },
          mutableGetter: "mutableLatestUtterances",
        },
      ],
      removedNumbers: [
        2,
      ],
    },
    {
      kind: "struct",
      ctor: ConversationState_Utterance,
      initFn: initConversationState_Utterance,
      name: "Utterance",
      parentCtor: ConversationState,
      fields: [
        {
          name: "text",
          property: "text",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "relative_timestamp_seconds",
          property: "relativeTimestampSeconds",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "float32",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: ConversationState,
      initFn: initConversationState,
      name: "ConversationState",
      fields: [
        {
          name: "accumulated_text",
          property: "accumulatedText",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "participant_states",
          property: "participantStates",
          number: 3,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: ConversationState_ParticipantState,
            },
            keyChain: "participant.id",
          },
          mutableGetter: "mutableParticipantStates",
          indexable: {
            searchMethod: "searchParticipantStates",
            keyFn: (v) => v.participant.id,
          },
        },
        {
          name: "participants",
          property: "participants",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: x_call_utils.Participant,
            },
          },
          mutableGetter: "mutableParticipants",
        },
        {
          name: "last_update",
          property: "lastUpdate",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "crm_context",
          property: "crmContext",
          number: 6,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: x_crm.MeetingCrmLink,
            },
          },
        },
        {
          name: "detected_language",
          property: "detectedLanguage",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
      removedNumbers: [
        0,
        2,
      ],
    },
    {
      kind: "struct",
      ctor: ConversationSummary,
      initFn: initConversationSummary,
      name: "ConversationSummary",
      fields: [
        {
          name: "summary",
          property: "summary",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: UploadMetadata_KnownParticipant,
      initFn: initUploadMetadata_KnownParticipant,
      name: "KnownParticipant",
      parentCtor: UploadMetadata,
      fields: [
        {
          name: "name",
          property: "name",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "email",
          property: "email",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: UploadMetadata,
      initFn: initUploadMetadata,
      name: "UploadMetadata",
      fields: [
        {
          name: "meeting_id",
          property: "meetingId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "upload_id",
          property: "uploadId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "meeting_title",
          property: "meetingTitle",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "file_extension",
          property: "fileExtension",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "known_participants",
          property: "knownParticipants",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: UploadMetadata_KnownParticipant,
            },
          },
          mutableGetter: "mutableKnownParticipants",
        },
        {
          name: "host_user_name",
          property: "hostUserName",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "host_company_name",
          property: "hostCompanyName",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "status",
          property: "status",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "progress",
          property: "progress",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "error",
          property: "error",
          number: 9,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: RecallDesktopInfo,
      initFn: initRecallDesktopInfo,
      name: "RecallDesktopInfo",
      fields: [
        {
          name: "meeting_id",
          property: "meetingId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "recall_recording_id",
          property: "recallRecordingId",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "upload_token",
          property: "uploadToken",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "api_url",
          property: "apiUrl",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "created_at",
          property: "createdAt",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
      ],
    },
  ]
);
